import { render, staticRenderFns } from "./isBannedColumn.vue?vue&type=template&id=396a7710"
import script from "./isBannedColumn.vue?vue&type=script&lang=ts"
export * from "./isBannedColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports